import { fetchLocation } from "../api/fetchLocation"
import { fetchCoordinates } from "../api/fetchLocation"

export const MAP_OPTIONS = fetchLocation()
export const COORDINATES = fetchCoordinates()
